import React from 'react'
import { Button, Modal, Form, Input,  Select,Space } from 'antd';
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import styles from "./styles.module.css";
import { toast, ToastContainer } from 'react-toastify';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
function CreatePermission({setShowAddPermissionModel,showAddPermissionModel,setPermissionData}) {
  // return (
  //   <div>CreatePermission</div>
  // )

  const [form] = Form.useForm();

  const handleModalClose = ()=>{
    setShowAddPermissionModel(!showAddPermissionModel);
    form.resetFields();
  }

  const handlePermissionSubmit = () =>{

    form
    .validateFields() // Validate all fields
    .then(async (values) => {

      const { permissionValues } = values;

      if (!permissionValues || permissionValues.length === 0) {
        toast.error('Please add at least one permission value.');
        return;
      }
     
      const response = await BreathAPIs.createPermission(values);
      // console.log('response: ',response);
      setPermissionData(response.data.data)
      toast.success(response.data.message);
      handleModalClose();
    })
    .catch((errorInfo) => {
      console.error('Validation Failed:', errorInfo.message ? errorInfo.message : 'All the mandatory fields of the form are not filled');
      // toast.error(response.data.message)
      toast.error(errorInfo?.response?.data?.message || 'Please fill the form')
    });

  }

  return(
    <>
    <ToastContainer> </ToastContainer>
    <Modal
    title="Create Permission"
    open={showAddPermissionModel}
    onOk={() => { handlePermissionSubmit() }}
    onCancel={()=>{handleModalClose()}}
     okText="Submit"
    >
      <div>
      <Form
        initialValues={{
          permissionName: '',
          allowChildPermissions: null,
          permissionValues: null
        }}
        form={form}
        layout="vertical"
      >
      
        <Form.Item name="permissionName" label="Permission Name" rules={[{ message: 'Please enter permission name', required: true },]}>
          <Input
            placeholder="Enter Permission Name"
          // onChange={(e) => setUserGroupFormData((prev) => ({ ...prev, groupName: e.target.value }))}
          />
        </Form.Item>
        <Form.Item name="allowChildPermissions" label="Allow Child Permissions" rules={[{ message: 'Please select a value for Allow Child Permissions', required: true },]}>
          <Select options={[{ value: true, label: 'True' }, { value: false, label: 'False' }]}
            placeholder="Select True / False"
          //  onChange={(e) => setUserGroupFormData((prev) => ({ ...prev, isActive: e.target.value }))}
          />
        </Form.Item>
        <Form.List name="permissionValues">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, fieldKey, ...restField }) => (
              <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                <Form.Item
                  {...restField}
                  name={[name, 'permissionValue']}
                  fieldKey={[fieldKey, 'permissionValue']}
                  rules={[{ required: true, message: 'Please enter permission Value' }]}
                >
                  <Input placeholder="Enter Permission Value" />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <Button  onClick={() => add()} block icon={<PlusOutlined />}>
                Add Permission Value
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>


      </Form>
      </div>
    
    </Modal>
    </>
  )
}

export default CreatePermission